import type { z } from 'zod';

export type FieldErrors = Record<string, string>;

/**
 * Validate form data with a shared schema before sending, so people get the
 * same messages instantly that the server would give.
 */
export function validate<S extends z.ZodType>(
  schema: S,
  data: unknown,
): { ok: true; data: z.output<S> } | { ok: false; fields: FieldErrors } {
  const result = schema.safeParse(data);
  if (result.success) return { ok: true, data: result.data };
  const fields: FieldErrors = {};
  for (const issue of result.error.issues) fields[issue.path.join('.') || '_'] ??= issue.message;
  return { ok: false, fields };
}

/** Form fields as a plain object of strings (files excluded). */
export function formValues(form: HTMLFormElement): Record<string, string> {
  const values: Record<string, string> = {};
  new FormData(form).forEach((v, k) => {
    if (typeof v === 'string') values[k] = v;
  });
  return values;
}
